import './styles/ProgressBar.css';

const ProgressBar = () => (
  <div className="progress-bar" />
);

export default ProgressBar;
